module.exports = {"id":"dp1_3l1q2","text":"Managing Information","instructions":"What is the main purpose of backing up digital files?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"1.3","questionType":"PickOne","random":true,"options":[{"id":"dp1_3l1q2-a1","text":"To recover files if data is lost","score":1.8},{"id":"dp1_3l1q2-a2","text":"To make files open faster","score":0},{"id":"dp1_3l1q2-a3","text":"To reduce file size permanently","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.3/l1q2.json
// module id = 967
// module chunks = 41